import { Button, ButtonProps } from "@headlessui/react";
import { FC } from "react";
import cn from "classnames";
export const Pill: FC<ButtonProps> = ({ className, ...props }) => (
  <Button
    className={cn(
      "rounded-corner-pill active:bg-swdc-gray-100 text-body-primary bg-background-highlight py-1 pr-0.5 pl-3 hover:underline",
      className,
    )}
    {...props}
  />
);
